import React from "react";
import { Badge, Col, Drawer, Row } from "antd";
import { IQuestion } from "pages/homework";
import style from "./HomeworkDrawer.module.scss";
import _ from "underscore";

interface HomeworkDrawerProps {
    visible: boolean;
    data: IQuestion[];
    answeredTopics: number[];
    onClose: () => void;
    onClick: (index: number) => void;
}

export default function HomeworkDrawer({
    visible,
    data,
    answeredTopics,
    onClose,
    onClick
}: HomeworkDrawerProps) {
    function isAnswered(item: IQuestion) {
        if (item.topics && item.topics.length > 0) {
            return _.every(item.topics || [], topic =>
                answeredTopics.includes(topic.topicId)
            );
        } else {
            return answeredTopics.includes(item.topicId);
        }
    }

    return (
        <Drawer placement="right" closable onClose={onClose} visible={visible}>
            <Row className={style.Badge}>
                <Col span={8}>
                    <Badge status="success" text="已答" />
                </Col>
                <Col span={8}>
                    <Badge status="default" text="未答" />
                </Col>
            </Row>

            <h1 className={style.title}>答题卡</h1>

            <Row type="flex" gutter={[16, 16]}>
                {data.map((item, index) => (
                    <Col span={6} key={item.topicId}>
                        <button
                            className={`${style.item} ${
                                isAnswered(item) ? style.answered : ""
                            }`}
                            onClick={() => onClick(index)}>
                            {index + 1}
                        </button>
                    </Col>
                ))}
            </Row>
        </Drawer>
    );
}
